<template>

    <b-row id="team-listing" class="team-listing-container">

        <!-- <div v-for="(person, index) in teamMembers" :key='index' :class="{active : $route.params.name == person.url}" class="portrait-item">
        <router-link :to="'/team/'+person.url">
        <div class="text-overlay">
            <div class="overlay-content">
                <h3>{{person.name}}</h3>
                <p>{{person.profession}}</p>
                <p>Click to View More</p>
            </div>
        </div>
        <div class="person-image-container">
            <img :src="person.previewSecondary" class='person-image secondary'  :alt="person.name + ' - ' + person.profession + ' - Secondary Photo'">
            <img :src="person.preview" class='person-image primary' :alt="person.name + ' - ' + person.profession + ' - Primary Photo'">
        </div>
        </router-link>
    </div> -->


        <b-col v-for="(person, index) in teamMembers" :key='index' class="portrait" col md="3" sm="4" cols="6"
            @mouseenter="person.active = true" @mouseleave="person.active = false">

            <div class="aspect-ratio"></div>
            <b-img fluid class="bottom" :src="person.preview"></b-img>
            <b-img fluid class="top" :class="{ 'hide' : person.active == true}" :src="person.preview"></b-img>
            <div class="person-info" v-if='person.silhouette' :class="{ 'show' : person.active == true, 'show' : person.silhouette == true }">
                <h5>{{ person.name }}</h5>
                <p>{{ person.profession }}</p>
            </div>

              <div class="person-info" v-if='!person.silhouette' :class="{ 'show' : person.active == true }">
                <h5>{{ person.name }}</h5>
                <p>{{ person.profession }}</p>
            </div>

        </b-col>

                 <b-col class="end-of-team-cta">
            <router-link to="/careers">
                <div class="end-text">
                    <h3>Want to join us?</h3>
                    <p>Check out our available positions</p>
                </div>
            </router-link>
        </b-col>


    </b-row>

</template>

<script>
    import {
        Team
    } from '@/assets/js/team-members.js';

    export default {
        data() {
            return {
                person: null,
                teamMembers: Team
            };
        },
        props: ['Team'],
    }
</script>

<style lang="scss">
    @import '@/assets/css/teamListing.scss';
</style>